<template>
  <div class="organisation-wrap pt-20 pb-20">
    <div class="container mx-auto px-4">
      <!-- Titre principal -->
      <h2 class="text-3xl font-bold text-center mb-8 text-yellow-700 uppercase">
        ORGANISATION
      </h2>

      <!-- Responsables Institutionnels -->
      <section class="content-section mb-8">
        <h3 class="section-title mb-4">RESPONSABLES INSTITUTIONNELS</h3>
        <ul class="list-disc ps-4 mb-4">
          <li><strong>Chancelier :</strong> Mgr Roger Houngbédji, op.</li>
          <li><strong>Directeur :</strong> Père Rodrigue Gbédjinou</li>
          <li><strong>Direction académique :</strong> Père Aimé Hounzandji</li>
          <li><strong>Directeurs de la recherche et de l’innovation méthodologique :</strong> Pères Ambroise Kinhoun & Aimé Hounzandji</li>
          <li><strong>Animation spirituelle :</strong> Père Maurice Hounmènou</li>
          <li><strong>Accompagnement institutionnel :</strong> Père Maurice Hounmènou</li>
          <li><strong>Affaires matérielles et financières :</strong> Père Maurice Hounmènou</li>
        </ul>
      </section>

      <!-- Responsables des Services de Formation -->
      <section class="content-section mb-8">
        <h3 class="section-title mb-4">RESPONSABLES DES SERVICES DE FORMATION</h3>
        <ul class="list-disc ps-4 mb-4">
          <li><strong>Équipe de formation et pôles d’enseignement :</strong></li>
          <ul class="ps-4">
            <li>Père Aimé Hounzandji (Culture Générale)</li>
            <li>Père Ambroise Kinhoun (Histoire de l’Église)</li>
            <li>Père Mathieu Aïfan (Bible)</li>
            <li>Père Maurice Hounmènou (Vie de foi)</li>
            <li>Père Rodrigue Gbédjinou (Théologie)</li>
          </ul>
          <li><strong>Revue et Bibliothèque :</strong> Père Henri Azankposso</li>
          <li><strong>Équipe de l’accompagnement institutionnel :</strong></li>
          <ul class="ps-4">
            <li>Père Maurice Hounmènou</li>
            <li>Père Bienvenu Akodoh</li>
            <li>Père Didier Agondjihossou</li>
            <li>Père Marc Hounnon</li>
          </ul>
        </ul>
      </section>

      <!-- Le Personnel -->
      <section class="content-section">
        <h3 class="section-title mb-4">LE PERSONNEL</h3>
        <ul class="list-disc ps-4 mb-4">
          <li><strong>Assistante de direction :</strong> Sr Marcelle Aholou</li>
          <li><strong>Secrétaire académique :</strong> Josith Adiho</li>
          <li><strong>Comptabilité et cours</strong></li>
          <li><strong>Présence à la bibliothèque :</strong> Bénévoles de l’EITP</li>
          <li><strong>Entretien ; Maintenance informatique</strong></li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "OrganisationPage",
  setup() {
    return {};
  },
});
</script>

<style scoped>
.organisation-wrap {
  background-color: #fff;
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.section-title {
  color: #2b3a67;
  font-weight: 600;
}

.content-section p,
.content-section li {
  margin-bottom: 1rem;
}

ul ul {
  list-style-type: circle;
  margin-top: 0.5rem;
}
</style>
